import { Injectable } from '@angular/core';

export const sKey = {
	isGuestUser: 'isGuestUser',
	mwHelp: 'mwHelp',
	olHelp: 'olHelp',
	sdHelp: 'sdHelp'
};
@Injectable({
	providedIn: 'root'
})
export class SessionStorageService {
	setItem(key: string, value: string) {
		sessionStorage.setItem(key, value);
	}

	getItem(key: string): string {
		return sessionStorage.getItem(key);
	}

	removeItem(key: string): void {
		sessionStorage.removeItem(key);
	}
}
